<template>
  <div>
    <div class="is-border ">
      <spinner-round
        :is-loading="loading"
        v-if="loading"></spinner-round>
      <table-controls-vue
        v-if="!loading && items.length"
        :has-sticky="true"
        :no-scroll-direction="true">
        <table class="table is-narrow is-fullwidth is-last-fixed-small has-actionsontd">
          <thead class="has-cells-vcentered">
            <tr class="is-size-6">
              <th>
                <sortable
                  sort-id="name"
                  @sort="sort('name', $event)"
                  :sort="sortBy.name"
                  label="Nom"></sortable>
              </th>
              <th class="is-narrow">
                Membres
              </th>
              <th class="has-text-centered"></th>
            </tr>
          </thead>
          <tbody class="has-cells-vcentered">
            <tr
              v-for="(group) in items"
              :key="group.pk"
              class="is-size-6"
              :id="'e' + group.pk"
              :class="{'has-status-bar--left has-status-bar--draft': lastOpenedItemPk === group.pk}">
              <td class="is-cell-hoverable">
                <router-link
                  :to="{name: 'GroupVue', params: {id: group.pk}}"
                  class="fullLink">
                  {{ group.name }}
                </router-link>
              </td>
              <td class="is-narrow">
                <span>{{ group.users.length }} membre<span v-if="group.users.length > 1">s</span></span>
              </td>
              <td>
                <display-button-list
                  :buttons="buttonList"
                  :data="group">
                </display-button-list>
              </td>
            </tr>
          </tbody>
        </table>
      </table-controls-vue>
      <div v-show="!loading && !items.length">
        <div class="is-padding">
          <h2 class="title is-3 has-text-weight-bold">
            Aucun groupe disponible
          </h2>
        </div>
      </div>
      <pagination
        :loading="loading"
        :current-page="currentPage"
        :total-page="totalPage"
        @changePage="loadItems($event)"></pagination>
    </div>
  </div>
</template>

<script>
import { GenericList, Sort, DefaultValues, Filter } from '@/mixins'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'GroupList',
  mixins: [GenericList, Sort, DefaultValues, Filter],
  data () {
    return {
      buttonList: [
        {
          action: (id) => {
            this.$router.push({ name: 'GroupVue', params: { id } })
          },
          icon: 'fa-eye'
        }
      ],
      loadDocuments: this.loadItems,
      service: 'GROUP',
      query: {
        is_commercial: 0
      }
    }
  },
  computed: {
    ...mapState(['lastOpenedItemPk']),
    ...mapGetters(['canAddUsers'])
  },
  created () {
    if (this.$route.name === 'GroupListInterne') {
      this.query.is_commercial = 0
    } else {
      this.query.is_commercial = 1
    }
  }
}
</script>
